import React, { Component } from 'react';
import Title from '../Title/Title';
import Spinner from '../Spinner/Spinner';
import SingleSignOn from '../SingleSignOn/SingleSignOn';
import './LogoutPage.scss';
import { CookieService } from '../../core/services/cookieService';

interface Props {
  SingleSignOnComponent: typeof SingleSignOn
  cookieService: ReturnType<typeof CookieService.Instance>
}

interface State {
  ready: boolean
}

class LogoutPage extends Component<Props, State> {
  static defaultProps

  constructor(props) {
    super(props);
    this.state = {
      ready: false
    };
  }

  componentDidMount() {
    (async () => {
      await this.props.cookieService.deleteAuthCookies();
      this.setState({ ready: true });
    })();
  }

  render() {
    return (
      <div className='logoutWrapper'>
        <Title name="Logging Out..." textPosition="auth-title--center" />
        <hr className="divider" />

        <Spinner />
        <p className="message">
          Please wait...
          <br />
          You're being logged out and you'll be redirected back to the website in a moment.
        </p>

        {this.state.ready && (
          <this.props.SingleSignOnComponent action="logout" />
        )}
      </div>
    );
  }
}

LogoutPage.defaultProps = {
  SingleSignOnComponent: SingleSignOn,
  cookieService: CookieService.Instance()
};

export default LogoutPage;
